import { ReactNode, useRef } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/Tabs";
import {
  NotificationTab,
  NOTIFICATION_TAB_SWIPE_THRESHOLD_PX,
  resolveTabAfterSwipe,
} from "./notificationsListQuery";

type Props = {
  activeTab: NotificationTab;
  onTabChange: (tab: NotificationTab) => void;
  showAutomationsTab: boolean;
  historyPanel: ReactNode;
  automationsPanel: ReactNode;
};

export function NotificationsTabs({
  activeTab,
  onTabChange,
  showAutomationsTab,
  historyPanel,
  automationsPanel,
}: Props) {
  const touchStartX = useRef<number | null>(null);

  function handleTouchStart(clientX: number) {
    touchStartX.current = clientX;
  }

  function handleTouchEnd(clientX: number) {
    if (touchStartX.current == null || !showAutomationsTab) return;

    const deltaX = touchStartX.current - clientX;
    touchStartX.current = null;

    const nextTab = resolveTabAfterSwipe(
      deltaX,
      activeTab,
      NOTIFICATION_TAB_SWIPE_THRESHOLD_PX
    );
    if (nextTab) onTabChange(nextTab);
  }

  if (!showAutomationsTab) {
    return <>{historyPanel}</>;
  }

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange(value as NotificationTab)}
      className="flex-1"
    >
      <TabsList aria-label="Seções de notificações">
        <TabsTrigger value="history">Histórico de envios</TabsTrigger>
        <TabsTrigger value="automations">Automações conhecidas</TabsTrigger>
      </TabsList>

      <div
        className="flex flex-1 flex-col touch-pan-y"
        onTouchStart={(event) => handleTouchStart(event.touches[0]?.clientX ?? 0)}
        onTouchEnd={(event) => handleTouchEnd(event.changedTouches[0]?.clientX ?? 0)}
      >
        <TabsContent value="history" className="mt-2 p-3 md:p-4">
          {historyPanel}
        </TabsContent>
        <TabsContent value="automations" className="mt-2 p-3 md:p-4">
          {automationsPanel}
        </TabsContent>
      </div>
    </Tabs>
  );
}
